import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const basicShareService = {
    queryData,
};

async function queryData(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.LOGIN_URL}/${tableName}/QueryData`, requestOptions).then(response => common.handleResponse(response));
}